<template>
  <div>
    home
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
    }
  },
  mounted(){
    this.loginFacebook();
  },
  methods:{
    loginFacebook(){
      const client_id='318215931980023';
      const redirect_uri='https://store.spinxh5.com/loading';
      const state='{st=state123abc,ds=123456789}'
      window.location.href=`https://www.facebook.com/v12.0/dialog/oauth?client_id=${client_id}&redirect_uri=${redirect_uri}&state=${state}`
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/page/home.vue